import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-mx-auto tw-max-w-1800 tw-px-md lg:tw-px-xl" }
const _hoisted_2 = {
  class: "tw-w-full sr-only",
  "aria-atomic": "true",
  "aria-live": "polite"
}
const _hoisted_3 = { class: "tw-w-full" }
const _hoisted_4 = { class: "tw-w-full tw-mt-xl" }
const _hoisted_5 = { class: "list-lines-four tw-w-full tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-3 xxl2:tw-grid-cols-4 tw-gap-xl md:tw-gap-x-xxl md:tw-gap-y-100 tw-mb-xxl" }
const _hoisted_6 = {
  key: 0,
  class: "tw-w-full tw-my-xxl"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Load More ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-md tw-ml-auto",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m16.312 9.76-1.008.992 3.072 3.36H9.24v1.44h9.136l-3.072 3.36 1.008.992 4.592-5.072-4.592-5.072Z",
    fill: "inherit"
  })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveFilters = _resolveComponent("ActiveFilters")!
  const _component_FilterOptions = _resolveComponent("FilterOptions")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_FeaturedCard = _resolveComponent("FeaturedCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Filters "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Live Region "),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.gridItems.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Now Showing " + _toDisplayString(_ctx.gridItems.length) + " Results ", 1 /* TEXT */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" / Live Region "),
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Active Filters "),
        _createVNode(_component_ActiveFilters, {
          activeFilters: _ctx.activeFilters,
          toggleFilterOption: _ctx.toggleFilterOption
        }, null, 8 /* PROPS */, ["activeFilters", "toggleFilterOption"]),
        _createCommentVNode(" / Active Filters "),
        _createCommentVNode(" Filter Options "),
        _createVNode(_component_FilterOptions, {
          isFilterActive: _ctx.isFilterActive,
          openPickerFilter: _ctx.openPickerFilter,
          currentSort: _ctx.currentSort,
          sortOptions: _ctx.sortOptions,
          handleSort: _ctx.handleSort,
          filterCategories: _ctx.filterCategories,
          toggleFilterOption: _ctx.toggleFilterOption
        }, null, 8 /* PROPS */, ["isFilterActive", "openPickerFilter", "currentSort", "sortOptions", "handleSort", "filterCategories", "toggleFilterOption"]),
        _createCommentVNode(" / Filter Options ")
      ]),
      _createCommentVNode(" / Results "),
      _createCommentVNode(" Results "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "tw-w-full tw-flex tw-flex-col tw-relative",
              key: item.id
            }, [
              (item.title)
                ? (_openBlock(), _createBlock(_component_ProductCard, {
                    key: 0,
                    product: item
                  }, null, 8 /* PROPS */, ["product"]))
                : _createCommentVNode("v-if", true),
              (!item.title)
                ? (_openBlock(), _createBlock(_component_FeaturedCard, {
                    key: 1,
                    block: item
                  }, null, 8 /* PROPS */, ["block"]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createCommentVNode(" / Results "),
      _createCommentVNode(" Pagination "),
      (_ctx.showLoadMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-secondary tw-w-full tw-max-w-350 tw-mx-auto",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoadMore && _ctx.handleLoadMore(...args))),
              "aria-label": "Load more items into results list"
            }, _hoisted_9)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" / Pagination ")
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}